import {getAxios, getEndpointBase} from "./base.api";
import * as querystring from "../utils/querystring";
import { ResponseStatus } from "../../interfaces/ecom/schema";

const AUTHENTICATED_ENDPOINT = "ToggleFavouriteRecipe";
const axios = getAxios();

interface IRequestData {
    RecipeId: string;
    RecipeURL: string;
}

export async function toggleFavouriteRecipe({RecipeId, RecipeURL}: IRequestData): Promise<ResponseStatus> {
    const apiUrl = getEndpointBase(AUTHENTICATED_ENDPOINT);
    const queryString = querystring.stringify({
        RecipeId,
        RecipeURL,
    });
    const response = await axios.post(`${apiUrl}?${queryString}`);
    if (response.status >= 200 && response.status < 300) {
        return response.data;
    } else {
        console.error(`API Endpoint error: ${response.statusText}`)
    }

    // TODO: handle errors, do not send empty response
    return {};
}

